<template>
  <div v-if="newSrNo !== null">
    <b-row v-if="newSrNo !== ''">
      <VueGlow
        v-if="blinking"
        class="mt-50 mx-1"
        color="red"
        fade
        interval="2"
        elevation="4"
        intense
        :intensity="2"
      >
        <b-badge
          class="badge-round cursor-pointer px-75 text-left"
          :style="
            highlight
              ? 'background-color: #c60000; white-space:normal; display:inline-flex'
              : 'background-color: rgba(197,0,1, 0.5); white-space:normal; display:inline-flex'
          "
        >
          <small
            class="p-0 m-0 text-white font-weight-bolder text-uppercase nowrap"
          >Curr. - Sr No.: {{ newSrNo.replace('Additional', 'Addl.') }}
            <a
              v-if="vcLink"
              :href="vcLink"
              target="_blank"
              rel="noopener noreferrer"
              class="vc-link-badge"
              @click.stop
            > - VC LINK</a></small>
        </b-badge>
      </VueGlow>
      <b-badge
        v-else
        class="badge-round cursor-pointer px-75 text-left mt-50 mx-1"
        :style="
          highlight
            ? 'background-color: #c60000; white-space:normal; display:inline-flex'
            : 'background-color: #BEBEBE; white-space:normal; display:inline-flex'
        "
      >
        <small
          class="p-0 m-0 text-white font-weight-bolder text-uppercase nowrap"
        >Curr. - Sr No.: {{ newSrNo.replace('Additional', 'Addl.') }}
          <a
            v-if="vcLink"
            :href="vcLink"
            target="_blank"
            rel="noopener noreferrer"
            class="vc-link-badge"
            @click.stop
          > - VC LINK</a></small>
      </b-badge>
    </b-row>
  </div>
</template>

<script>
import { BBadge, BRow } from 'bootstrap-vue'
import moment from 'moment'
import VueGlow from 'vue-glow'

export default {
  components: {
    BBadge,
    BRow,
    VueGlow,
  },
  props: {
    date: {
      default: null,
    },
    court_id: {
      default: null,
    },
    court_no: {
      default: -1,
    },
    serial_no: {
      default: -1,
    },
  },
  data() {
    return {
      courtId: this.court_id,
      courtNo: this.court_no,
      serialNo: this.serial_no,
      newSrNo: null,
      cDate: this.date,
      highlight: true,
      blinking: false,
      vcLink: null,
    }
  },
  watch: {
    '$store.state.hearingStore.courtsDisplayBoard': {
      handler() {
        this.syncDisplayBoardData()
      },
      deep: true,
      immediate: true,
    },
  },
  beforeMount() {},
  methods: {
    syncDisplayBoardData() {
      const cId = String(this.courtId)
      const boards = this.$store.state.hearingStore.courtsDisplayBoard
      if (Object.prototype.hasOwnProperty.call(boards, cId)) {
        this.getData({
          db: boards[cId],
        })
      }
    },
    getData({ db }) {
      console.log('CDATE', this.courtNo)
      this.vcLink = null
      if (moment().format('DD-MM-YYYY') === this.cDate) {
        const nsr = []

        const court = db[0]
        const srNo = db[1]
        const list = db.length > 2 ? db[2] : []
        const col = db.length > 3 ? db[3] : []
        const vcLinkRow = db.find(
          row => Array.isArray(row)
            && row.length
            && String(row[0]).trim().toLowerCase() === 'vc link',
        )
        let index
        if (this.courtNo == -10) {
          index = court.indexOf('C.J.')
          console.log(index)
        } else if (this.courtNo == -15) {
          index = court.indexOf('In Chamber')
        } else {
          index = court.indexOf(String(this.courtNo))
        }

        console.log('Index', index)
        if (index >= 0) {
          if (
            srNo[index] !== 'Court NOT in session!'
            && srNo[index] !== 'CourtNOTinsession!'
          ) {
            console.log(parseInt(srNo[index]), parseInt(this.serialNo))
            nsr.push(srNo[index])
            if (parseInt(srNo[index]) > parseInt(this.serialNo)) {
              this.highlight = false
            } else {
              this.highlight = true
            }
            if (parseInt(srNo[index]) > parseInt(this.serialNo)) {
              this.blinking = false
            } else if (parseInt(srNo[index]) - 10 < parseInt(this.serialNo)) {
              this.blinking = false
            } else {
              this.blinking = true
            }
          }
          if (list.length) {
            if (
              list[index] !== 'Court NOT in session!'
              && list[index] !== 'CourtNOTinsession!'
            ) {
              nsr.push(list[index])
            }
          }
          if (col.length) {
            if (col[index]) {
              if (
                col[index] !== 'Court NOT in session!'
                && col[index] !== 'CourtNOTinsession!'
              ) nsr.push(col[index])
            }
          }
          if (vcLinkRow && vcLinkRow[index]) {
            const vcValue = String(vcLinkRow[index]).trim()
            if (vcValue.startsWith('http')) {
              this.vcLink = vcValue
            }
          }
          if (nsr) {
            this.newSrNo = nsr.join(', ')
          }
        }
      }
    },
  },
}
</script>

<style scoped>
.vc-link-badge {
  color: #ffffff;
  text-decoration: underline;
  font-weight: 700;
  font-size: 0.7rem;
  white-space: nowrap;
}
</style>
